<hr [class]="type + ' ' + orientation" />
